import type { CosignatureSupervisors } from "@/core/types";
import { permissionsRequestsTyped } from "@/api/(requests)/permissionsTyped";

export async function getCosignatureSupervisors(): Promise<CosignatureSupervisors> {
  return permissionsRequestsTyped.get_cosign_supervisors();
}
